<template>
    <b-modal
        v-model="shown"
        centered
        title="Export Summary PDF"
        lazy
    >

        <div>
            <b-form-checkbox v-model="showPricePerGuest">
                Show Price per Guest
            </b-form-checkbox>
        </div>

        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="close"
            >
                Close
            </b-btn>
            <b-btn
                :href="link"
                :target="openInNewTab ? '_blank' : null"
                variant="success"
            >
                Export
            </b-btn>
        </div>

    </b-modal>
</template>

<script>
export default {

    data() {
        return {
            shown: false,
            showPricePerGuest: false,
            url: '',
            openInNewTab: false,
        };
    },

    computed: {
        link() {
            return `${this.url}?ppg=${this.showPricePerGuest ? 1 : 0}`;
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openExportSummaryPdfModal, ({ url, openInNewTab }) => {
            this.url = url;
            this.openInNewTab = openInNewTab;
            this.showPricePerGuest = false;
            this.shown = true;
        });
    },

    methods: {
        close() {
            this.shown = false;
        },
    },

};
</script>
